import { render } from "./KSCreateNode.vue?vue&type=template&id=5f06f981"
import script from "./KSCreateNode.vue?vue&type=script&lang=js"
export * from "./KSCreateNode.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__